import React from 'react';
import { DollarSign, TrendingUp, TrendingDown, Calculator, Image as ImageIcon } from 'lucide-react';

function FinancialSummary({ financials, paymentImages = [], onShowImages }) {
  const {
    totalCollected,
    totalToDeposit,
    deliveryCount,
    pricePerDelivery,
    totalServiceFee,
    totalExchange,
  } = financials;

  const hasImages = paymentImages && paymentImages.length > 0;

  // Debug logs
  console.log('FinancialSummary - paymentImages:', paymentImages);
  console.log('FinancialSummary - hasImages:', hasImages);
  console.log('FinancialSummary - onShowImages:', onShowImages);

  return (
    <div className="bg-gradient-to-br from-[#B1336E] to-[#E6B43C] rounded-2xl shadow-lg p-6 text-white">
      <div className="flex items-center gap-3 mb-6">
        <div className="relative">
          <button 
            type="button"
            onClick={() => {
              console.log('Button clicked! hasImages:', hasImages);
              console.log('Images to show:', paymentImages);
              if (hasImages && onShowImages) {
                onShowImages();
              }
            }}
            disabled={!hasImages}
            className={`w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center relative group transition-all ${
              hasImages 
                ? 'cursor-pointer hover:bg-white/30 hover:scale-110' 
                : 'cursor-default opacity-50'
            }`}
          >
            <DollarSign className="w-6 h-6" />
            {hasImages && (
              <div className="absolute -top-1 -right-1 w-5 h-5 bg-green-500 rounded-full flex items-center justify-center shadow-lg border-2 border-white">
                <span className="text-xs text-white font-bold font-montserrat">
                  {paymentImages.length}
                </span>
              </div>
            )}
            <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-3 px-3 py-2 bg-slate-900 text-white text-xs rounded-lg font-montserrat shadow-lg w-64 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
              {hasImages 
                ? `Ver ${paymentImages.length} comprobante${paymentImages.length !== 1 ? 's' : ''} de depósito` 
                : 'No hay comprobantes disponibles para esta fecha'}
            </span>
          </button>
        </div>
        <div>
          <div className="flex items-center gap-2">
            <h2 className="text-xl font-extrabold font-montserrat">Resumen Financiero</h2>
            {hasImages && (
              <span className="text-xs bg-white/20 px-2 py-1 rounded-full font-semibold flex items-center gap-1">
                <ImageIcon className="w-3 h-3" />
                {paymentImages.length}
              </span>
            )}
          </div>
          <p className="text-sm text-white/80 font-montserrat">Análisis del día seleccionado</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Total Collected */}
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
          <div className="flex items-center gap-2 mb-2">
            <TrendingUp className="w-4 h-4" />
            <p className="text-xs font-medium font-montserrat">Total Recaudado</p>
          </div>
          <p className="text-2xl font-extrabold font-montserrat">
            S/ {totalCollected.toFixed(2)}
          </p>
          <p className="text-xs text-white/70 mt-1 font-montserrat">
            {totalExchange > 0 
              ? `Cobrado + Transferencias - Cambio (S/ ${totalExchange.toFixed(2)})`
              : 'Cobrado + Transferencias'}
          </p>
        </div>

        {/* Service Fee */}
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
          <div className="flex items-center gap-2 mb-2">
            <Calculator className="w-4 h-4" />
            <p className="text-xs font-medium font-montserrat">Costo Servicio</p>
          </div>
          <p className="text-2xl font-extrabold font-montserrat">
            S/ {totalServiceFee.toFixed(2)}
          </p>
          <p className="text-xs text-white/70 mt-1 font-montserrat">
            {deliveryCount} × S/ {pricePerDelivery.toFixed(2)} prom.
          </p>
        </div>

        {/* Total to Deposit */}
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
          <div className="flex items-center gap-2 mb-2">
            <TrendingDown className="w-4 h-4" />
            <p className="text-xs font-medium font-montserrat">A Depositar</p>
          </div>
          <p className="text-2xl font-extrabold font-montserrat">
            S/ {totalToDeposit.toFixed(2)}
          </p>
          <p className="text-xs text-white/70 mt-1 font-montserrat">
            Recaudado - Servicio
          </p>
        </div>

        {/* Deliveries Count */}
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
          <div className="flex items-center gap-2 mb-2">
            <DollarSign className="w-4 h-4" />
            <p className="text-xs font-medium font-montserrat">Entregas Cobradas</p>
          </div>
          <p className="text-2xl font-extrabold font-montserrat">
            {deliveryCount}
          </p>
          <p className="text-xs text-white/70 mt-1 font-montserrat">
            Entregados + Rechazados
          </p>
        </div>
      </div>

      {/* Note */}
      <div className="mt-4 pt-4 border-t border-white/20">
        <p className="text-xs text-white/80 font-montserrat">
          <strong>Nota:</strong> Solo se contabilizan entregas con estado "Entregado" o "Rechazado"
        </p>
      </div>
    </div>
  );
}

export default FinancialSummary;